<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card>
        <mat-card-content>
            <div class="d-flex align-items-end mb-3">
                <h1 class="fs-3 fw-light mb-0">DIOs Encerrados Automaticamente</h1>
                <button mat-icon-button color="primary" class="d-print-none btn-sm ms-auto" (click)="toggleFilters = !toggleFilters">
                    <mat-icon>tune</mat-icon>
                </button>
                <button mat-flat-button class="d-print-none ms-3 bg-gray-400" (click)="print()">IMPRIMIR</button>
            </div>

            <!-- FILTROS -->
            <ng-collapse [toggle]="toggleFilters">
                <div class="border-top px-1 py-3">
                    <div class="row align-items-end">
                        <div class="col-12 col-md-3">
                            <mat-form-field class="w-100">
                                <mat-label>Data Início</mat-label>
                                <input matInput [matDatepicker]="dataInicio" name="dataInicio" 
                                    autocomplete="off" [(ngModel)]="filters.dataInicio" required>
                                <mat-datepicker-toggle matIconSuffix [for]="dataInicio"></mat-datepicker-toggle>
                                <mat-datepicker #dataInicio></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-3">
                            <mat-form-field class="w-100">
                                <mat-label>Data Fim</mat-label>
                                <input matInput [matDatepicker]="dataFim" name="dataFim" 
                                    autocomplete="off" [(ngModel)]="filters.dataFim" required>
                                <mat-datepicker-toggle matIconSuffix [for]="dataFim"></mat-datepicker-toggle>
                                <mat-datepicker #dataFim></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-3">
                            <select-beneficiaria 
                                [(ngModel)]="filters.beneficiaria"
                                (beneficiariaChange)="setBeneficiaria($event)">
                            </select-beneficiaria>                      
                        </div>
                        <div class="col-12 col-md-3">
                            <ng-select name="contrato" [items]="contratos" bindValue="id" bindLabel="nome" 
                                placeholder="Contrato" [searchFn]="searchFn" [(ngModel)]="filters.contrato" 
                                [compareWith]="compareWith">
                            </ng-select>
                        </div>
                        <div class="col-12 col-md-2 ms-auto mt-3">
                            <button mat-flat-button color="accent" class="w-100" (click)="search()" 
                                [disabled]="loading">
                                <span *ngIf="!loading">FILTRAR</span>
                                <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-collapse>

            <!-- TABLE -->
            <div class="overflow-x-auto mt-3">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Prefixo</th>
                            <th>Quantidade de DIOs</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="dataSource.length === 0 && !loading">
                            <td colspan="3" class="text-center text-muted">Nenhum registro encontrado</td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="3" class="text-center">
                                <mat-spinner diameter="30" class="mx-auto"></mat-spinner>
                            </td>
                        </tr>                        
                        <tr *ngFor="let item of dataSource; index as index;">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.prefixo }}</td>
                            <td>{{ item.quantidade }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </mat-card-content>
    </mat-card>
</div>
